import { render, staticRenderFns } from "./architecture-drivers-overview.vue?vue&type=template&id=00511bf1&scoped=true"
import script from "./architecture-drivers-overview.vue?vue&type=script&lang=js"
export * from "./architecture-drivers-overview.vue?vue&type=script&lang=js"
import style0 from "./architecture-drivers-overview.vue?vue&type=style&index=0&id=00511bf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00511bf1",
  null
  
)

export default component.exports